import { render } from "./AccountDefaultSettings.vue?vue&type=template&id=530afbdc&scoped=true"
import script from "./AccountDefaultSettings.vue?vue&type=script&lang=js"
export * from "./AccountDefaultSettings.vue?vue&type=script&lang=js"

import "./AccountDefaultSettings.vue?vue&type=style&index=0&id=530afbdc&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-530afbdc"]])

export default __exports__